import RichTextInput from 'ra-input-rich-text';
import React, {Fragment, useEffect, useRef, useState} from 'react';
import TextField from '@material-ui/core/TextField';
import {BooleanInput, ImageField, ImageInput, ReferenceArrayInput, required, SelectArrayInput, SelectInput, TextInput} from 'react-admin';
import {ARTICLE_STATES, COLUMN, COLUMN_CATEGORY, KEYWORDS} from '../../consts/Names';
import '../../fonts/fonts.css';
import { trimValidation } from '../../consts/Validators';
import Quill from "quill";

const Parchment = Quill.import('parchment');
const ImageBlot = Quill.import('formats/image');
const toolbarOptions = [
    [{size: []}],
    ['bold', 'underline', 'strike'],
    [{color: []}, {background: []}],
    [{script: 'super'}, {script: 'sub'}],
    [{header: '1'}, {header: '2'}, 'blockquote', 'code-block'],
    [{list: 'ordered'}, {list: 'bullet'}, {indent: '-1'}, {indent: '+1'}],
    ['direction', {align: []}],
    ['link', 'image', 'video'],
    ['clean']
];


export const ColumnForm = (props) => {
   const {classes} = props;
   const inputRef = useRef(null);
    const [altImage, setAltImage] = useState("");
    const [showAlt, setShowAlt] = useState(false);
    const [imageRef, setImageRef] = useState(null);
    const [mouse, setMouse] = useState({
        clientX: 0,
        clientY: 0
    });

    useEffect(() => {
        function printMousePos(event) {
            if(showAlt) return;
            setMouse({
                clientX: event.pageX,
                clientY: event.pageY
            })
        }

        document.addEventListener("click", printMousePos);
        return function cleanup() {
            document.removeEventListener("click", printMousePos)
        }
    }, [showAlt])

    const configureQuill = (quill) => {
        quill.root.addEventListener('dblclick', (e) => {
            setShowAlt(false);
            setImageRef(null);
            setAltImage("")
            const img = Parchment.find(e.target);
            if (!(img instanceof ImageBlot)) {
                return;
            }
            setShowAlt(true);
            setImageRef(img)
            setAltImage(img.domNode.getAttribute("alt") || "")
            if(inputRef) {
                // @ts-ignore
                inputRef.current.focus()
            }
        });
    }

    const onChangeAlt = (e) => {
        setAltImage(e.target.value)
        if(!imageRef) return;
        // @ts-ignore
        imageRef.domNode.setAttribute("alt", e.target.value)
    }

    return (
      <Fragment>
         <TextInput fullWidth={true} label="Title" source="title" validate={[required(), trimValidation]} />
         <ReferenceArrayInput className={classes.category} label="Category" source="category_ids" reference="categories" validate={[required()]}>
            <SelectArrayInput optionText="name" />
         </ReferenceArrayInput>
         <SelectInput className={classes.category} label="State of publish" source={COLUMN.state} validate={[required()]} choices={ARTICLE_STATES} />
         <BooleanInput source="isHightlight" label="Highlighted" />
         <ImageInput
            className={classes.imageFld}
            source="images"
            label="Related pictures"
            accept="image/*"
            multiple={true}
            placeholder={<p>Drop your image here</p>}
            validate={[required()]}>
            <ImageField source={COLUMN_CATEGORY.image} />
         </ImageInput>
         <TextInput fullWidth={false} label="Image Alt Text" source="image_alt_text" validate={[required(), trimValidation]} />
         {/*<ReferenceArrayInput label="Keywords" source="keyword_ids" reference={KEYWORDS.SOURCE} className={classes.category}>*/}
         {/*   <SelectArrayInput optionText="name" />*/}
         {/*</ReferenceArrayInput>*/}
         <TextInput fullWidth={true} label="Meta Keywords" source="meta_keywords" validate={[required(), trimValidation]} />
         <TextInput fullWidth={true} label="Meta Description" source="meta_description" validate={[required(), trimValidation]} />
         <TextInput fullWidth={true} label="Name of a writer" source={COLUMN.author_name} />
         <TextInput fullWidth={true} label="Description" source={COLUMN.author_description} />
         <ImageInput className={classes.imageFld} source={COLUMN.author_photo} label="Author picture" accept="image/*"  placeholder={<p>Drop your image here</p>}>
            <ImageField source={COLUMN.author_photo}/>
         </ImageInput>
         <RichTextInput
            configureQuill={configureQuill}
            fullWidth={true}
            source="content"
            validate={[required(), trimValidation]}
            label="Article"
            toolbar={toolbarOptions}
         />
         {showAlt && (
            <div style={{position: 'absolute', top: mouse.clientY, left: mouse.clientX, background: 'rgba(255,255,255,0.8)'}}>
               <TextField inputRef={inputRef} label="Image Alt Text" type="text" value={altImage} onBlur={() => setShowAlt(false)} onChange={onChangeAlt} />
            </div>
         )}
      </Fragment>
   );
};
